import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import DashboardSidebar from "../components/dashboardSidebar";
import ServicesCard from "../components/servicesCard";
import AstrologersCard from "../components/astrologersCard";
import BookingsCard from "../components/bookingsCard";

function UserDashborad() {
  const ServicesCardData = [
    {
      title: "Horoscope",
      image: "/images/service1.svg",
    },
    {
      title: "Astrology",
      image: "/images/service2.svg",
    },
    {
      title: "Kundli",
      image: "/images/service3.svg",
    },
    {
      title: "Kundli Matching",
      image: "/images/service4.svg",
    },
    {
      title: "Consultation",
      image: "/images/service5.svg",
    },
  ];
  const AstrologersCardData = [
    {
      name: "Acharya Vivek Joshi",
      profileImage: "/images/profile1.png",
      price: "100.50",
      expertise: "Yantra",
      experience: "20",
      rating: "4.5",
      online: true,
    },
    {
      name: "Acharya Vivek Joshi",
      profileImage: "/images/profile2.png",
      price: "100.50",
      expertise: "Yantra",
      experience: "20",
      rating: "4.5",
      online: false,
    },
    {
      name: "Acharya Vivek Joshi",
      profileImage: "/images/profile3.png",
      price: "100.50",
      expertise: "Yantra",
      experience: "20",
      rating: "4.5",
      online: true,
    },
  ];
  const BookingsCardData = [
    {
      astrologerName: "Acharya Vivek Joshi",
      astrologerImage: "/images/profile1.png",
      astrologerExpertise: "Yantra",
      bookingDate: "2022-01-01",
    },
    {
      astrologerName: "Acharya Vivek Joshi",
      astrologerImage: "/images/profile2.png",
      astrologerExpertise: "Yantra",
      bookingDate: "2022-01-01",
    },
  ];

  return (
    <>
      <section className="dashborad-bg py-8 md:py-10 relative">
        <div className="container">
          <div className="dashborad-header flex flex-wrap gap-[10px] items-center justify-between mb-4">
            <h1 className="web-h3">Dashboard</h1>
            <div className="search-box relative">
              <button className="absolute top-[15px] left-[10px]">
                <img src="/images/search.svg" alt="search" />
              </button>
              <input
                type="text"
                className="custom-input !pl-[45px]"
                placeholder="Search here"
              />
            </div>
          </div>

          <div className="dashborad-content flex flex-col xl:flex-row gap-[15px] lg:gap-[30px] xl:gap-[40px]">
            <div className="dashborad-content-left xl:w-[calc(100%-340px)] flex flex-col gap-[30px]">
              <div className="trending-services-section">
                <div className="section-header mb-3">
                  <h2 className="web-h4 text-gray-950">Trending Services</h2>
                </div>

                <div className="slider-bg relative w-full overflow-hidden">
                  <Swiper
                    spaceBetween={16}
                    breakpoints={{
                      640: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 5,
                        spaceBetween: 24,
                      },
                    }}
                    pagination={{
                      clickable: true,
                      el: ".swiper-pagination-custom",
                      bulletClass: "swiper-pagination-bullet-custom",
                      bulletActiveClass:
                        "swiper-pagination-bullet-active-custom",
                    }}
                    modules={[Pagination]}
                    className="mySwiper"
                  >
                    {ServicesCardData.map((item, index) => (
                      <SwiperSlide key={index} className="max-w-[100%]">
                        <ServicesCard
                          key={index}
                          title={item.title}
                          image={item.image}
                        />
                      </SwiperSlide>
                    ))}

                    <SwiperSlide className="hidden sm:block"></SwiperSlide>
                  </Swiper>
                  <div className="swiper-pagination-custom flex justify-center mt-6 gap-[5px] items-center"></div>
                </div>
              </div>

              <div className="our-astrologers-section">
                <div className="section-header mb-3 flex items-center justify-between flex-wrap gap-[15px]">
                  <h2 className="web-h4 text-gray-950">Our Astrologers</h2>
                  <button className="text-link">View All</button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[15px]">
                  {AstrologersCardData.map((item, index) => (
                    <AstrologersCard
                      key={index}
                      name={item.name}
                      profileImage={item.profileImage}
                      price={item.price}
                      expertise={item.expertise}
                      online={item.online}
                      experience={item.experience}
                      rating={item.rating}
                    />
                  ))}
                </div>
              </div>

              <div className="our-bookings-section">
                <div className="section-header mb-3 flex items-center justify-between flex-wrap gap-[15px]">
                  <h2 className="web-h4 text-gray-950">My Bookings</h2>
                  <button className="text-link">View All</button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px]">
                  {BookingsCardData.map((item, index) => (
                    <BookingsCard
                      key={index}
                      astrologerName={item.astrologerName}
                      astrologerImage={item.astrologerImage}
                      astrologerExpertise={item.astrologerExpertise}
                      bookingDate={item.bookingDate}
                    />
                  ))}
                </div>
              </div>
            </div>

            <DashboardSidebar />
          </div>
        </div>
      </section>
    </>
  );
}

export default UserDashborad;
